export default {
  title: 'My subtitled videos',
  loadingText: 'Loading subtitles...',
  createButton: 'Create',
  emptyState: {
    title: 'Start subtitling your videos',
    description: 'This feature allows you to generate subtitles but also to generate a transcription of your video. Click on "Start" to begin processing. Note that generation can take several minutes.',
    buttonText: 'Start'
  },
  card: {
    created: 'Created on',
    downloadLanguage: 'Download ({language})',
    view: 'View video'
  },
  editor: {
    title: 'Subtitle Editor',
    undo: 'Undo',
    redo: 'Redo',
    saved: 'Saved',
    saving: 'Saving...',
    unsaved: 'Unsaved changes',
    saveTooltip: 'Save changes (Ctrl+S)'
  },
  download: {
    title: 'Download Subtitles',
    language: 'Language: {language}',
    format: 'Download format',
    selectFormat: 'Select Format',
    selectSubtitles: 'Select Subtitles to Download',
    advancedOptions: 'Advanced Options',
    includeMetadata: 'Include metadata',
    zipMultiple: 'Download as ZIP archive',
    useSlugFilename: 'Use technical names for files',
    preview: 'Preview',
    downloadButton: 'Download'
  },
  upload: {
    uploading: 'Uploading...',
    started: 'Upload started',
    plannedSubtitles: 'Subtitles to generate',
    status: {
      preparing: 'Preparing upload...',
      uploading: 'Uploading file...',
      processing: 'Processing video...'
    },
    modal: {
      title: 'Upload Video',
      configure: 'Configure Subtitles',
      dragDrop: 'Drag and drop your video here',
      dropHere: 'Drop your file here',
      or: 'or',
      browse: 'Browse Files',
      fromLibrary: 'Choose from Library',
      uploadNew: 'Upload New Video',
      uploadNewDescription: 'Drag and drop or browse to upload a new video file',
      fromLibraryDescription: 'Select an existing video from your library',
      chooseMethod: 'How would you like to add your video?',
      chooseMethodDescription: 'Select whether to upload a new video or choose from your existing library',
      tryDifferentFilter: 'Try a different filter or search term',
      supportedFormats: 'Supported formats: MP4, AVI, MOV, MKV, WebM',
      libraryTitle: 'Video Library',
      searchVideos: 'Search videos...',
      filterAll: 'All',
      filterNoSubtitles: 'No subtitles',
      filterRecent: 'Recent',
      noSubtitles: 'No subtitles yet',
      noVideosFound: 'No videos found',
      select: 'Select',
      existingVideo: 'Existing video',
      existingSubtitles: 'This video already has the following subtitles:',
      allowRegeneration: 'Allow regeneration of existing subtitles',
      selectLanguages: 'Select subtitle languages to generate',
      popular: 'Popular',
      presetPopular: 'Popular languages',
      presetEurope: 'European languages',
      presetAll: 'All languages',
      advancedOptions: 'Advanced Options',
      audioDescription: 'Audio Description',
      simplified: 'Simplified (Easy to read)',
      summary: '{count} language(s) selected',
      additionalSubtitles: 'Additional: {types}',
      startUpload: 'Start Upload',
      errorNotVideo: 'Please select a video file',
      errorTooLarge: 'File is too large (max 2GB)'
    }
  },
  delete: {
    title: 'Delete video',
    message: 'Are you sure you want to delete "{video}" and all its subtitles? This action cannot be undone.'
  }
}
